import styled, { css } from 'styled-components';
import { baseFontWeight } from '/shared/styled/GlobalStyle/GlobalStyle';
import Colours from '/shared/styled/Colours';

interface Props {
  $position?: 'above' | 'below';
  $align?: 'left' | 'right';
  $absolute?: boolean;
  $isInline?: boolean;
  $noWrap?: boolean;
}

function positionStyle({ $position }: Props) {
  if ($position === 'above') {
    return css`
      padding-bottom: 0.5rem;
    `;
  }
  if ($position === 'below') {
    return css`
      padding-top: 0.5rem;
    `;
  }
}

function alignStyle({ $align }: Props) {
  if ($align === 'left') {
    return css`
      text-align: left;
      align-self: flex-start;
    `;
  }
  if ($align === 'right') {
    return css`
      text-align: right;
      align-self: flex-end;
    `;
  }
}

function absoluteStyle({ $absolute }: Props) {
  if ($absolute) {
    return css`
      position: absolute;
    `;
  }
}

function setInline({ $isInline }: Props) {
  if ($isInline) {
    return css`
      display: inline;
    `;
  }
}

function noWrapStyle({ $noWrap }: Props) {
  if ($noWrap) {
    return css`
      white-space: nowrap;
    `;
  }
}

export default styled.div<Props>`
  font-size: 0.8rem;
  color: ${Colours.grey};
  letter-spacing: 0.25px;
  line-height: 1.5;
  margin-left: 2rem;
  ${positionStyle}
  ${alignStyle}
  ${absoluteStyle}
  ${baseFontWeight}
  ${setInline}
  ${noWrapStyle}
`;
